module.exports = __webpack_public_path__ + "img/bwecp-line-short.5ad013e0.svg";